import {
  Id,
  PinnedMessagesData,
  MessagesResponse as Response,
  convertAddOrUpdateOrPinnedEvent,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from 'chat/shared/queries/keys'
import { produce } from 'immer'

type PinnedVariables = {
  conversationId: string
  messageId: string
}

export function usePinMessage(id: Id) {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: pinMessage,
    onSuccess: async event => {
      const key = keys.pinnedMessages(id)
      const data = client.getQueryData<PinnedMessagesData>(key)

      if (!data?.pinnedMessages) {
        return
      }

      await client.cancelQueries({ queryKey: key })
      client.setQueryData<PinnedMessagesData>(
        key,
        produce(data, updatedData => {
          if (
            updatedData.pinnedMessages.findIndex(m => {
              return m.id === event.pinnedMessages[0].id
            }) === -1
          )
            updatedData.pinnedMessages.push(
              convertAddOrUpdateOrPinnedEvent(event.pinnedMessages[0])
            )
        })
      )
    },
  })

  function pinMessage({ conversationId, messageId }: PinnedVariables) {
    return server.post<Response.PinnedMessageResponse>(
      `/v2/chat/conversations/${conversationId}/messages/${messageId}/pinned`,
      {}
    )
  }
}
